import { render } from "./CompanyDepartments.vue?vue&type=template&id=5c0be66a&scoped=true"
import script from "./CompanyDepartments.vue?vue&type=script&lang=js"
export * from "./CompanyDepartments.vue?vue&type=script&lang=js"

import "./CompanyDepartments.vue?vue&type=style&index=0&id=5c0be66a&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0be66a"]])

export default __exports__